import React from 'react';
import Cookies from 'js-cookie';
import Lottie from 'lottie-react-web';
import PropTypes from 'prop-types';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { HashLink as LinkHash } from 'react-router-hash-link';

// Own constants/actions/components
import {
  OUTSESION,
  LOGIN_URL,
  DEFAULT_URL_EXP,
  RECOVERY_ACCOUNT_LINK,
  RECOVERY_NIP_LINK,
  REGISTER_LINK,
  CP_LINK,
} from 'constants/Constants';
import amLoader from '../../assets/am-loader.json';

const Header = (props) => {
  const { session, account, points, name, loader } = props;

  const handleOutSesion = () => {
    Cookies.remove('frontSession');
    window.location.href = OUTSESION;
  };

  const renderSessionActive = () => {
    return (
      <div className="row text-center">
        {
          loader ? (
            <div className="loader-cp container">
              <Lottie
                width={50}
                options={{
                  animationData: amLoader,
                }} />
            </div>
          ) : (
            <>
              <Col lg={7}>
                <div className="header-group logged-in">
                  <div className="userinfo">
                    <h5>{`¡Hola ${name}!`}</h5>
                    <p className="small">
                      No. de Cuenta:
                      <strong>{account}</strong>
                      {`| Saldo: ${points} Puntos Aeroméxico Rewards`}
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={5}>
                <div>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={handleOutSesion}>
                    Cerrar sesión
                  </button>
                </div>
              </Col>
            </>
          )
        }
      </div>
    );
  };

  const renderNotSession = () => {
    return (
      <Form className="header-group login row" action={LOGIN_URL} noValidate method="POST">
        <Col lg={3} className="px-2">
          <input id="autologin" type="hidden" name="autologin" value="true" />
          <input id="url" type="hidden" name="url" value={DEFAULT_URL_EXP} />
          <div className="form-group login-account-group">
            <input
              className="form-control"
              id="login-account"
              name="j_username"
              required
              placeholder="No. Cuenta Aeroméxico Rewards" />
            <span className="form-text small">
              <a href={RECOVERY_ACCOUNT_LINK} className="text-midnight-blue">Recuperar tu No. de Cuenta</a>
            </span>
          </div>
        </Col>
        <Col lg={3} className="px-2">
          <div className="form-group login-password-group">
            <input
              className="form-control"
              id="login-password"
              name="j_password"
              type="password"
              required
              placeholder="Contraseña" />
            <span className="form-text small">
              <a href={RECOVERY_NIP_LINK} className="text-midnight-blue">Olvidé mi contraseña</a>
            </span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="d-flex">
            <button type="submit" className="btn btn-secondary login-button btn ml-15">Inicia sesión</button>
            <a className="btn btn-primary mx-15" href={REGISTER_LINK}>Inscríbete</a>
          </div>
        </Col>
      </Form>
    );
  };

  return (
    <div className="site-header">
      <Container>
        <Row className="py-15">
          <Col xs={10} lg={4} xl={3}>
            <a href={CP_LINK}>
              <img src="https://s3media.aeromexicorewards.com/clubpremierstyleguide/amstyleguide/images/am-rewards-blue.svg" alt="logo" className="w-100" />
            </a>
          </Col>
          <Col lg={2} xl={2} className="d-none d-xl-block">
            <div className="header-group contact text-center">
              <LinkHash to="#Contacto" className="contact-link" id="highlight-contact-info">
                <span className="fas fa-phone-square" />
              </LinkHash>
              <p className="small">Contacto</p>
            </div>
          </Col>
          <Col lg={6} className="d-none d-xl-block">
            {session ? renderSessionActive() : renderNotSession() }
          </Col>
          <Col xs={6} md={6} lg={8} className="d-none d-lg-block d-xl-none text-right">
            { session
              ? (
                <a className="btn btn-secondary btn-sm mt-10" href={OUTSESION}>
                  Cerrar sesión
                </a>
              )
              : (
                <>
                  <a className="btn btn-secondary btn-sm mx-15" href={LOGIN_URL}>Inicia sesión</a>
                  <a className="btn btn-primary btn-sm mx-15" href={REGISTER_LINK}>Inscríbete</a>
                </>
              )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Header.defaultProps = {
  account: '',
  points: '',
  name: '',
};

Header.propTypes = {
  session: PropTypes.bool.isRequired,
  account: PropTypes.string,
  points: PropTypes.string,
  name: PropTypes.string,
  loader: PropTypes.bool.isRequired,
};

export default Header;
